import * as React from 'react'

interface IProps extends React.Props<AccordionItem> {
    title: string,
    isOpen?: boolean;
    onToggle?: () => void;
}

interface IState {
    isOpen: boolean;
}

export class AccordionItem extends React.Component<IProps, IState> {
    static defaultProps = {
        title: '',
        isOpen: false,
        onTrigglerClick: (idx: number) => { },
    }

    get isOpen() {
        if (this.props.isOpen !== undefined) {
            return this.props.isOpen
        }
        return this.state.isOpen
    }

    get onToggle() {
        return this.props.onToggle || (() => this.setState({ isOpen: !this.state.isOpen }))
    }

    constructor(props) {
        super(props);
        this.state = {
            isOpen: this.props.isOpen
        }
    }

    render() {
        const { title } = this.props

        const openClass = this.isOpen ? 'open' : '';

        return (
            <div className={`cpg-react-accordion-item ${openClass}`}>
                <h3 className="cpg-react-accordion-trigger" onClick={this.onToggle}>{title}</h3>
                {this.isOpen && this.props.children}
            </div>
        )
    }
}
